import React, { useState, useEffect, useRef } from 'react';
import { Button, Checkbox, MenuItem, Popover, Stack, FormControlLabel, Typography } from '@mui/material';
import { getDecodedToken, getSector } from '../../service/service';
import useStyles from '../jobs/jobs_styles';
import AnalyticsVisualization from '../framework/analyticsVisualization';
import { dashboardUrl } from '../../service/config';
import { ReactComponent as FilterIcon } from '../../assets/ml_summary_filter.svg';
import './dataGrowth.scss';
import PageWrapper from 'components/Common/PageWraper';
import { useTheme } from "@mui/material/styles";

const TableauDataGrowth = () => {
	interface CheckedList {
		sectors: string[];
		site: string[];
		environment: string[];
	}
	const theme = useTheme();
	const userSector = getDecodedToken()?.sector?.name?.toLowerCase();
	const classes = useStyles();
	const dataFetchedRef = useRef(false);
	const [sectorOptionsList, setSectorOptionsList] = useState<string[]>([]);
	const [filterMenu, setFilterMenu] = useState<{
		mouseX: number;
		mouseY: number;
	} | null>(null);
	const [itemsChecked, setItemsChecked] = useState(false);
	const [checkedList, setCheckedList] = useState<CheckedList>({
		sectors: [],
		site: [],
		environment: []
	});
	const [selectedFilter, setSelectedFilter] = useState<string>('Sectors');
	const [selectedSite, setSelectedSite] = useState<string[]>([]);
	const [selectedEnvironment, setSelectedEnvironment] = useState<string>('all');
	const [selectedSector, setSelectedSector] = useState<string[]>([]);

	const filterClick = (event: any) => {
		event.preventDefault();
		setFilterMenu(
			filterMenu === null
				? {
					mouseX: parseInt(event.clientX) - 20,
					mouseY: parseInt(event.clientY) - 6
				}
				: null
		);
	};

	const handleClose = () => {
		localStorage.removeItem('presto-summary-sector-filter');
		setCheckedList({
			sectors: [],
			site: [],
			environment: []
		});
		setItemsChecked(false);
	};

	const handleMenuItemClick = (filter: string) => {
		setSelectedFilter(filter);
		if (filter === 'Sectors') {
			setItemsChecked(false);
		}
	};

	useEffect(() => {
		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;

		if (userSector === 'all') fetchSectorOptionsData();
		let storedSectorFilter = localStorage.getItem('presto-summary-sector-filter')
			? JSON.parse(localStorage.getItem('presto-summary-sector-filter') ?? '')
			: null;
		if (storedSectorFilter) {
			setCheckedList(storedSectorFilter);
			setSelectedSector(storedSectorFilter.sectors);
		}
	}, []);

	async function fetchSectorOptionsData() {
		const sectorRes = await getSector('1', '100', '');
		if (sectorRes.success) {
			setSectorOptionsList(
				sectorRes.data.sector.map((x: any) => {
					if (x.name === 'S&T') {
						return 'SNT';
					} else if (x.name === 'Europe') {
						return 'EUROPE';
					} else {
						return x.name;
					}
				})
			);
		}
	}

	const handleOkClick = () => {
		let updatedSiteList: string[] = [];
		let updatedEnvironmentList: string;

		if (checkedList.site.includes('All')) {
			updatedSiteList = ['Default'];
		} else {
			updatedSiteList = checkedList.site;
		}

		if (checkedList.environment.includes('Cockpit') && checkedList.environment.includes('Global')) {
			updatedEnvironmentList = 'all';
		} else if (checkedList.environment.includes('Global')) {
			updatedEnvironmentList = 'Global';
		} else if (checkedList.environment.includes('Cockpit')) {
			updatedEnvironmentList = 'Cockpit';
		} else {
			updatedEnvironmentList = '';
		}

		setSelectedEnvironment(updatedEnvironmentList);
		setSelectedSector(checkedList.sectors);
		setSelectedSite(updatedSiteList);
		console.log(selectedSite, selectedEnvironment, selectedSite, 'checked list');
		handleViewClose();
	};

	const handleViewClose = () => {
		setFilterMenu(null);
	};

	const handleSectorChange = (updatedSelection: string[]) => {
		setCheckedList((prevState) => ({
			...prevState,
			sectors: updatedSelection
		}));
	};

	const selectAllCheck = (e: any) => {
		const { checked } = e.target;
		if (selectedFilter === 'Site') {
			if (checked) {
				setCheckedList((prevState) => ({
					...prevState,
					site: ['All', 'Default']
				}));
			} else {
				setCheckedList((prevState) => ({
					...prevState,
					site: []
				}));
			}
		} else if (selectedFilter === 'Environment') {
			const allOptions = ['All', 'Global', 'Cockpit'];
			setCheckedList((prevState) => ({
				...prevState,
				environment: checked ? allOptions : []
			}));
		} else {
			setCheckedList((prevState) => ({
				...prevState,
				sectors: checked ? sectorOptionsList : []
			}));
		}
		setItemsChecked(checked);
	};

	const handleSiteChange = (value: string) => {
		let updatedList: string[];

		if (value === 'All') {
			updatedList = checkedList.site.includes('All') ? [] : ['All', 'Default'];
		} else {
			if (checkedList.site.includes('All')) {
				updatedList = [];
			} else {
				updatedList = checkedList.site.includes(value)
					? checkedList.site.filter((item) => item !== value)
					: [...checkedList.site, value];
			}
		}

		setCheckedList((prevState) => ({
			...prevState,
			site: updatedList
		}));
	};

	const handleEnvironmentChange = (value: string) => {
		let updatedList: string[];

		if (value === 'All') {
			updatedList = ['Cockpit', 'Global'];
		} else {
			updatedList = checkedList.environment.includes(value)
				? checkedList.environment.filter((item) => item !== value)
				: [...checkedList.environment, value];
		}

		setCheckedList((prevState) => ({
			...prevState,
			environment: updatedList
		}));
	};

	return (
		<PageWrapper>
			<div className="datagrowth-exexutions-dateFilter-div">
				<Stack alignItems="flex-end">
					{userSector === 'all' ? (
						<FilterIcon
							onClick={filterClick}
							style={{ cursor: 'pointer' }}
						/>
					) : (
						<Typography sx={{ px: 1, color: theme.palette.dropdown.menuItemText }}>
							Sector: {getDecodedToken()?.sector?.name}
						</Typography>
					)}

					<Popover
						open={filterMenu !== null}
						onClose={handleViewClose}
						anchorReference="anchorPosition"
						anchorPosition={
							filterMenu !== null
								? { top: filterMenu.mouseY, left: filterMenu.mouseX }
								: undefined
						}
					>
						<Stack
							sx={{
								backgroundColor: `${theme.palette.dropdown.menuItemBackground} !important`,
								minWidth: 280,
							}}
						>
							{/* Header */}
							<Stack
								direction="row"
								justifyContent="space-between"
								alignItems="center"
								sx={{
									px: 2,
									py: 1,
									borderBottom: `1px solid ${theme.palette.dropdown.border}`,
								}}
							>
								<Typography
									sx={{ color: `${theme.palette.dropdown.menuItemText} !important` }}
								>
									Filters
								</Typography>
								<Stack direction="row" spacing={1}>
									<Button
										variant="contained"
										className={classes.cancelBtn}
										onClick={handleClose}
									>
										CLEAR
									</Button>
									<Button
										variant="contained"
										className={classes.okBtn}
										onClick={handleOkClick}
									>
										APPLY
									</Button>
								</Stack>
							</Stack>

							{/* Side navigation list */}
							<Stack
								direction="row"
								sx={{
									minHeight: 220,
								}}
							>
								<Stack
									sx={{
										minWidth: 150,
										backgroundColor: `${theme.palette.dropdown.menuItemBackground} !important`,
										borderRight: `1px solid ${theme.palette.dropdown.border}`,
									}}
								>
									{['Sectors', 'Site', 'Environment'].map((filter: string) => (
										<MenuItem
											key={filter}
											onClick={() => handleMenuItemClick(filter)}
											selected={filter === selectedFilter}
											sx={{
												borderBottom: `1px solid ${theme.palette.dropdown.border}`,
												color: `${theme.palette.dropdown.menuItemText} !important`,
												'&.Mui-selected': {
													backgroundColor: `${theme.palette.dropdown.menuItemSelected} !important`,
													color: `${theme.palette.dropdown.menuItemHoverText} !important`,
												},
												'&.Mui-selected:hover': {
													backgroundColor: `${theme.palette.dropdown.menuItemHover} !important`,
													color: `${theme.palette.dropdown.menuItemHoverText} !important`,
												},
												'&:hover': {
													backgroundColor: `${theme.palette.dropdown.menuItemHover} !important`,
													color: `${theme.palette.dropdown.menuItemHoverText} !important`,
												},
											}}
										>
											<Typography variant='filterText'>{filter}</Typography>
										</MenuItem>
									))}
								</Stack>

								{/* Right-hand panel */}
								<Stack sx={{ flex: 1, p: 1, maxHeight: 240, overflowY: 'auto' }}>
									{selectedFilter === 'Sectors' && (
										<>
											<MenuItem
												disableGutters
												sx={{
													'&:hover': {
														backgroundColor: `${theme.palette.dropdown.menuItemHover} !important`,
														'& .MuiFormControlLabel-label': {
															color: `${theme.palette.dropdown.menuItemHoverText} !important`,
														},
													},
												}}
											>
												<FormControlLabel
													label={
														<Typography variant='filterText' sx={{ color: `${theme.palette.dropdown.menuItemText} !important` }}>All</Typography>
													}
													sx={{
														'& .MuiFormControlLabel-label': {
															color: `${theme.palette.dropdown.menuItemText} !important`,
														},
													}}
													control={
														<Checkbox
															color="success"
															value="all"
															checked={itemsChecked}
															onChange={(e) => selectAllCheck(e)}
															sx={{
																'& .MuiSvgIcon-root': {
																	color: `${theme.palette.dropdown.checkBox} !important`,
																},
															}}
														/>
													}
												/>
											</MenuItem>
											{sectorOptionsList?.map((filter: any) => (
												<MenuItem key={filter} disableGutters
													sx={{
														'&:hover': {
															backgroundColor: `${theme.palette.dropdown.menuItemHover} !important`,
															'& .MuiFormControlLabel-label': {
																color: `${theme.palette.dropdown.menuItemHoverText} !important`,
															},
														},
													}}
												>
													<FormControlLabel
														label={
															<Typography variant='filterText' sx={{ color: `${theme.palette.dropdown.menuItemText} !important` }}>{filter}</Typography>
														}
														sx={{
															'& .MuiFormControlLabel-label': {
																color: `${theme.palette.dropdown.menuItemText} !important`,
															},
														}}
														control={
															<Checkbox
																color="success"
																value={filter}
																checked={checkedList.sectors.includes(filter)}
																onChange={() => {
																	const updatedSelection = checkedList.sectors.includes(
																		filter
																	)
																		? checkedList.sectors.filter(
																			(item) => item !== filter
																		)
																		: [...checkedList.sectors, filter];
																	handleSectorChange(updatedSelection);
																}}
																sx={{
																	'& .MuiSvgIcon-root': {
																		color: `${theme.palette.dropdown.checkBox} !important`,
																	},
																}}
															/>
														}
													/>
												</MenuItem>
											))}
										</>
									)}

									{selectedFilter === 'Site' && (
										<Stack
											sx={{
												backgroundColor: `${theme.palette.dropdown.menuItemBackground} !important`,
												borderRadius: 1,
												p: 1,
												minWidth: 200,
											}}
										>
											<Stack>
												{/* All */}
												<MenuItem disableGutters
													sx={{
														'&:hover': {
															backgroundColor: `${theme.palette.dropdown.menuItemHover} !important`,
															'& .MuiFormControlLabel-label': {
																color: `${theme.palette.dropdown.menuItemHoverText} !important`,
															},
														},
													}}
												>
													<FormControlLabel
														label="All"
														sx={{
															'& .MuiFormControlLabel-label': {
																color: `${theme.palette.dropdown.menuItemText} !important`,
															},
														}}
														control={
															<Checkbox
																color="success"
																value="All"
																checked={checkedList.site.includes('All')}
																onChange={() => handleSiteChange('All')}
																sx={{
																	'& .MuiSvgIcon-root': {
																		color: `${theme.palette.dropdown.checkBox} !important`,
																	},
																}}
															/>
														}
													/>
												</MenuItem>

												{/* Default */}
												<MenuItem disableGutters
													sx={{
														'&:hover': {
															backgroundColor: `${theme.palette.dropdown.menuItemHover} !important`,
															'& .MuiFormControlLabel-label': {
																color: `${theme.palette.dropdown.menuItemHoverText} !important`,
															},
														},
													}}
												>
													<FormControlLabel
														label="Default"
														sx={{
															'& .MuiFormControlLabel-label': {
																color: `${theme.palette.dropdown.menuItemText} !important`,
															},
														}}
														control={
															<Checkbox
																color="success"
																value="Default"
																checked={checkedList.site.includes('Default')}
																onChange={() => handleSiteChange('Default')}
																sx={{
																	'& .MuiSvgIcon-root': {
																		color: `${theme.palette.dropdown.checkBox} !important`,
																	},
																}}
															/>
														}
													/>
												</MenuItem>
											</Stack>
										</Stack>
									)}

									{selectedFilter === 'Environment' && (
										<Stack
											sx={{
												backgroundColor: `${theme.palette.dropdown.menuItemBackground} !important`,
												borderRadius: 1,
												p: 1,
												minWidth: 200,
											}}
										>
											<Stack>
												{/* All */}
												<MenuItem disableGutters
													sx={{
														'&:hover': {
															backgroundColor: `${theme.palette.dropdown.menuItemHover} !important`,
															'& .MuiFormControlLabel-label': {
																color: `${theme.palette.dropdown.menuItemHoverText} !important`,
															},
														},
													}}
												>
													<FormControlLabel
														label="All"
														sx={{
															'& .MuiFormControlLabel-label': {
																color: `${theme.palette.dropdown.menuItemText} !important`,
															},
														}}
														control={
															<Checkbox
																color="success"
																value="all"
																checked={itemsChecked}
																onChange={selectAllCheck}
																sx={{
																	'& .MuiSvgIcon-root': {
																		color: `${theme.palette.dropdown.checkBox} !important`,
																	},
																}}
															/>
														}
													/>
												</MenuItem>

												{/* Global */}
												<MenuItem disableGutters
													sx={{
														'&:hover': {
															backgroundColor: `${theme.palette.dropdown.menuItemHover} !important`,
															'& .MuiFormControlLabel-label': {
																color: `${theme.palette.dropdown.menuItemHoverText} !important`,
															},
														},
													}}
												>
													<FormControlLabel
														label="Global"
														sx={{
															'& .MuiFormControlLabel-label': {
																color: `${theme.palette.dropdown.menuItemText} !important`,
															},
														}}
														control={
															<Checkbox
																color="success"
																value="Global"
																checked={checkedList.environment.includes('Global')}
																onChange={() => handleEnvironmentChange('Global')}
																sx={{
																	'& .MuiSvgIcon-root': {
																		color: `${theme.palette.dropdown.checkBox} !important`,
																	},
																}}
															/>
														}
													/>
												</MenuItem>

												{/* Cockpit */}
												<MenuItem disableGutters
													sx={{
														'&:hover': {
															backgroundColor: `${theme.palette.dropdown.menuItemHover} !important`,
															'& .MuiFormControlLabel-label': {
																color: `${theme.palette.dropdown.menuItemHoverText} !important`,
															},
														},
													}}
												>
													<FormControlLabel
														label="Cockpit"
														sx={{
															'& .MuiFormControlLabel-label': {
																color: `${theme.palette.dropdown.menuItemText} !important`,
															},
														}}
														control={
															<Checkbox
																color="success"
																value="Cockpit"
																checked={checkedList.environment.includes('Cockpit')}
																onChange={() => handleEnvironmentChange('Cockpit')}
																sx={{
																	'& .MuiSvgIcon-root': {
																		color: `${theme.palette.dropdown.checkBox} !important`,
																	},
																}}
															/>
														}
													/>
												</MenuItem>
											</Stack>
										</Stack>
									)}
								</Stack>
							</Stack>
						</Stack>
					</Popover>
				</Stack>


				<AnalyticsVisualization
					params={{
						dashboardUrl: dashboardUrl.dataGrowthTableauTotalCountOfDataSource,
						className: 'dataGrowthframeContainer',
						otherParams: {
							'var-sector': selectedSector.join(','),
							'var-instance': selectedEnvironment.split(','),
							'var-site': selectedSite
						},
						seamless: true
					}}
				/>

				<div className="second-iframe-container-tableau">
					<div className="left-iframe-div-tableau">
						<AnalyticsVisualization
							params={{
								dashboardUrl: dashboardUrl.dataGrowthTableauTotalCountOfExtracts,
								className: 'dataGrowthLeftframeContainer',
								otherParams: {
									'var-sector': selectedSector.join(','),
									'var-instance': selectedEnvironment.split(','),
									'var-site': selectedSite
								},
								seamless: true
							}}
						/>
					</div>
					<div className="right-iframe-div-tableau">
						<AnalyticsVisualization
							params={{
								dashboardUrl: dashboardUrl.dataGrowthTableauTotalSizeOfExtract,
								className: 'datagrowthTableauTotalSizeOfExtract',
								otherParams: {
									'var-sector': selectedSector.join(','),
									'var-instance': selectedEnvironment.split(','),
									'var-site': selectedSite
								},
								seamless: true
							}}
						/>
					</div>
				</div>
			</div>
		</PageWrapper>
	);
};

export default TableauDataGrowth;
